import { render, staticRenderFns } from "./VizChart.vue?vue&type=template&id=08c1db77"
import script from "./VizChart.vue?vue&type=script&lang=js"
export * from "./VizChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports